import { useEffect } from "react";
import { SITE_URL } from "../../utils/jsonld";

function setMetaByName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const JSONLD_SCRIPT_ID = "route-jsonld";

/**
 * Per-route SEO tags for a client-rendered (no-SSR) React app.
 * Updates the SAME tags index.html defines (found by name/property) rather than
 * duplicating them, and swaps a single route-specific JSON-LD <script> on navigation —
 * the site-wide Organization/WebSite/Product graph in index.html is left untouched.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = `${SITE_URL}/tivione-logo.jpg`,
  noindex = false,
  jsonLd = null,
}) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    window.scrollTo(0, 0);
    if (title) document.title = title;
    setMetaByName("description", description);
    setMetaByName(
      "robots",
      noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    );
    setCanonical(url);

    setMetaByProperty("og:title", title);
    setMetaByProperty("og:description", description);
    setMetaByProperty("og:url", url);
    setMetaByProperty("og:image", image);

    setMetaByName("twitter:title", title);
    setMetaByName("twitter:description", description);
    setMetaByName("twitter:url", url);
    setMetaByName("twitter:image", image);

    let script = document.getElementById(JSONLD_SCRIPT_ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = JSONLD_SCRIPT_ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      const s = document.getElementById(JSONLD_SCRIPT_ID);
      if (s) s.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, noindex, JSON.stringify(jsonLd)]);

  return null;
}
